export default __webpack_public_path__ + "static/media/Antlers of Bone and Horn.45d4e704.jpg";